export const breakpoints = { mobile: 0, tablet: 768, desktop: 1280 };
